import React from "react";

import { Link } from "@/components/Link";
import "@/assets/style/new_design.scss";
import iconWeb from "@/assets/img/new/icon-web.svg";
import iconMobile from "@/assets/img/new/icon-mobile.svg";
import iconKiosk from "@/assets/img/new/icon-kiosk.svg";
import iconTouch from "@/assets/img/new/icon-touch.svg";

const PlatformPage = () => {
    return (
        <>
            <section className="fp-container-fluid header__common header--platform">
                <div className="mobile-content"></div>
                <div className="fp-container">
                    <div className="fp-row">
                        <div className="cell-12 cell-lg-4 header-content">
                            <h1>Versatile Integration Options for Seamless Check-In Experiences
                            </h1>
                            <p>FurtherPass is designed with flexibility in mind, ensuring seamless integration with your existing
                                systems and processes. We offer multiple integration options to suit your specific needs:</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fp-container-fluid platform__a">
                <div className="fp-container">
                    <div className="fp-row">
                        <div className="cell-lg-3">
                            <div className="fp-card">
                                <img src={iconWeb} alt="icon-web" className="icon" />
                                <h3>Web Check-In Integration</h3>
                                <p>
                                    Airlines can integrate FurtherPass into their web check-in platforms using our robust APIs.
                                    Passengers can conveniently verify their travel documents and undergo admissibility checks directly on
                                    the airline's website.</p>
                                <p>
                                    Seamless integration ensures a smooth and efficient check-in process for web users without disrupting
                                    their familiar experience.
                                </p>
                            </div>
                        </div>
                        <div className="cell-lg-3">
                            <div className="fp-card">
                                <img src={iconMobile} alt="icon-mobile" className="icon" />
                                <h3>Mobile Check-In Integration</h3>
                                <p>
                                    FurtherPass offers comprehensive SDKs for easy integration with airline mobile applications.
                                    Passengers can effortlessly verify their travel documents and undergo admissibility checks using their
                                    mobile devices.</p>
                                <p>
                                    Mobile check-in becomes more convenient, secure, and compliant with the power of FurtherPass.
                                </p>
                            </div>
                        </div>
                        <div className="cell-lg-3">
                            <div className="fp-card">
                                <img src={iconKiosk} alt="icon-kiosk" className="icon" />
                                <h3>Self Check-In Kiosk Integration</h3>
                                <p>
                                    Enhance the self-service experience with FurtherPass integration into self check-in kiosks.
                                    Passengers can scan or upload their travel documents directly at the kiosk, allowing for automated
                                    verification and admissibility checks.
                                </p>
                                <p>
                                    Reduce wait times, streamline the check-in process, and provide passengers with a seamless self-service
                                    experience.
                                </p>
                            </div>
                        </div>
                        <div className="cell-lg-3">
                            <div className="fp-card">
                                <img src={iconTouch} alt="icon-touch" className="icon" />
                                <h3>Manual Check-In Empowerment</h3>
                                <p>
                                    Enable airline agents with FurtherPass's powerful features through DCS integration.
                                    Agents can use FurtherPass to guide and assist in admissibility compliance during the manual check-in
                                    process.</p>
                                <p>
                                    Streamline agent workflows, ensure accuracy, and reduce errors in document verification.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fp-container-fluid platform__b">
                <div className="fp-container">
                    <div className="fp-row row-1">
                        <div className="cell-lg-2 box-1">
                            <h2>Key Features</h2>
                        </div>
                        <div className="cell-lg-2 box-2">
                            <h4>Seamless Document Verification</h4>
                            <p>FurtherPass simplifies document verification for various travel documents and visas, streamlining a
                                complex process into a few easy steps.</p>
                        </div>
                        <div className="cell-lg-2 box-3">
                            <h4>Biometric Integration</h4>
                            <p>Our platform enables secure biometric identification, allowing passengers to use their facial
                                biometrics for verification, reducing the reliance on physical documents.</p>
                        </div>
                        <div className="cell-lg-2 box-4">
                            <h4>Admissibility Calculation</h4>
                            <p>FurtherPass calculates passenger admissibility based on nationality, document type, and destination
                                country travel rules, ensuring compliance.</p>

                        </div>
                        <div className="cell-lg-2 box-5">
                            <h4>Comprehensive API</h4>
                            <p>Our APIs facilitate smooth integration into your systems, providing real-time data for travel document
                                verification and admissibility checks.</p>
                        </div>
                        <div className="cell-lg-2 box-6">
                            <h4>Customizable Widgets</h4>
                            <p>Tailor FurtherPass to your brand's look and feel with customizable widgets that seamlessly blend into
                                your check-in process.</p>
                        </div>
                    </div>
                    <div className="fp-row">
                        <div className="cell-lg-12 box-7">
                            <h2>Benefits</h2>
                        </div>
                    </div>
                    <div className="fp-row">
                        <div className="cell-lg-2 box-8">
                            <h4>Operational Efficiency</h4>
                            <p>Reduce queues, minimize check-in time, and optimize the use of resources at the airport with
                                FurtherPass's streamlined processes.</p>
                        </div>
                        <div className="cell-lg-2 box-9">
                            <h4>Enhanced Passenger Experience</h4>
                            <p>Offer travelers a smoother, more convenient journey by simplifying document verification and reducing
                                waiting times.</p>
                        </div>
                        <div className="cell-lg-2 box-10">
                            <h4>Compliance and Accuracy</h4>
                            <p>Ensure compliance with immigration requirements and minimize the risk of errors with our advanced
                                admissibility checks.</p>
                        </div>
                        <div className="cell-lg-2 box-11">
                            <h4>Improved Staff Productivity</h4>
                            <p>Empower your airline agents with tools that enhance their capabilities, making their roles more
                                efficient and rewarding.</p>
                        </div>
                        <div className="cell-lg-2 box-12">
                            <h4>Cost Savings</h4>
                            <p>Streamlined operations lead to cost savings, making FurtherPass a cost-effective solution for
                                airlines.</p>
                        </div>
                        <div className="cell-lg-2 box-13">
                            <h4>Customer Loyalty</h4>
                            <p>Happy passengers are loyal passengers. By enhancing their experience, you can foster loyalty and
                                positive word-of-mouth.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fp-container-fluid platform__demo">
                <div className="fp-container">
                    <div className="fp-row">
                        <div className="cell-lg-10">
                            <h3>FurtherPass is not just a platform; it's a transformative solution that elevates your airline's
                                operations and enhances passenger satisfaction. Explore the integration options, key features, and
                                benefits, and take the first step toward operational excellence with FurtherPass.
                            </h3>
                        </div>
                    </div>
                    <div className="fp-row">
                        <div className="cta">
                            <a href={"/contact-us"} className="primary">
                                Request a Demo
                            </a>
                            <a href={"/contact-us"}>
                                Learn More
                            </a>
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default PlatformPage;
